import React, { useCallback, useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import ReactSelect from "react-select";
import { connect } from "formik";
import { string, bool, shape, arrayOf } from "prop-types";
import styles from "./styles";
import * as components from "./components";
import styled from "styled-components";
import { Error } from "components/shared/form";
import Label from "components/label";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Select = ({
  formik,
  name,
  placeholder,
  label,
  options,
  isCreatable = false,
  isMulti = false,
  handleChange = () => {},
  ...props
}) => {
  const Component = isCreatable ? CreatableSelect : ReactSelect;

  const onChange = useCallback(
    (option) => {
      const value = Array.isArray(option)
        ? option.map((o) => o?.value)
        : option?.value;

      formik.handleChange({ target: { name, value } });
      setValue(option);
      handleChange(option);
    },
    [formik, name, handleChange]
  );

  const [value, setValue] = useState(null);
  const { errors, touched, values } = { ...formik };

  const onBlur = () => {
    formik.handleBlur({ target: { name } });
  };

  useEffect(() => {
    const values = formik.values[name] || [];
    if (typeof values === "string") {
      setValue(mapStrValues(values));
    }
    if (Array.isArray(values)) {
      setValue(mapArrValues(values));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values[name]]);

  const mapStrValues = (value) => {
    const existingValues =
      options?.filter((o) => value === o?.value) || [];
    if (existingValues.length > 0) return existingValues;
    else return { label: value, value };
  };

  const mapArrValues = (values) => {
    const existingValues =
      options?.filter((o) => values.includes(o?.value)) || [];
    const newValues =
      values?.filter((v) => !existingValues.some((vil) => vil?.value === v)) ||
      [];
    return [
      ...existingValues,
      ...newValues.map((nv) => ({ label: nv, value: nv })),
    ];
  };

  const getStyles = useCallback(() => {
    return styles(!!isMulti);
  }, [isMulti]);

  return (
    <Container>
      <Label visible={values[name]} label={label || placeholder} />
      <Component
        styles={getStyles()}
        options={options}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        components={components}
        isMulti={isMulti}
        {...props}
      />
      {errors[name] && touched[name] && <Error>{errors[name]}</Error>}
    </Container>
  );
};

Select.propTypes = {
  name: string,
  label: string,
  placeholder: string,
  options: arrayOf(shape({ key: string, value: string })),
  isDisabled: bool,
  isMulti: bool,
  isCreatable: bool,
  props: shape({}),
};

export default connect(Select);
